import { createSlice } from '@reduxjs/toolkit';
import ApiService from 'services/ApiService';
import axios from 'services/ApiAdaptor';

const getMultipartConfig = () => {
  const token = window.localStorage.getItem('serviceToken');
  const config = {
    headers: {
      'content-type': 'multipart/form-data'
    }
  };
  if (token) {
    config.headers['x-access-token'] = token;
  }
  return config;
};

const initialState = {
  lists: {
    items: [],
    totalItems: 0
  },
  currentPage: 0,
  pageSize: 150,
  error: null,
  list: null
};

const slice = createSlice({
  name: 'customerCompany',
  initialState,
  reducers: {
    hasError(state, action) {
      state.error = action.payload;
    },
    getLists(state, action) {
      state.lists = action.payload;
      state.currentPage = action.payload.currentPage;
      state.pageSize = action.payload.pageSize;
    },
    getSelectLists(state, action) {
      state.lists = action.payload;
      state.currentPage = action.payload.currentPage;
      state.pageSize = action.payload.pageSize;
    },
    createCustomerCompany(state, action) {
      state.lists.items = [...state.lists.items, action.payload];
      state.lists.totalItems += 1;
    },
    updateCustomerCompany(state, action) {
      const updatedCompany = action.payload;
      state.lists.items = state.lists.items.map((item) => (item.id === updatedCompany.id ? updatedCompany : item));
    },
    deleteCustomerCompany(state, action) {
      const companyId = action.payload;
      state.lists.items = state.lists.items.filter((item) => item.id !== companyId);
      state.lists.totalItems -= 1;
    }
  }
});

export const { getLists, getSelectLists, createCustomerCompany, updateCustomerCompany, deleteCustomerCompany } = slice.actions;

export default slice.reducer;

export function getCustomerCompanyList(page, pageSize) {
  return async (dispatch) => {
    try {
      const objData = {
        path: '/customerCompany/list',
        params: { page, pageSize }
      };

      const response = await ApiService.get(objData);
      dispatch(
        getLists({
          items: response.data.items,
          totalItems: response.data.totalItems,
          currentPage: page - 1,
          pageSize: pageSize
        })
      );
    } catch (error) {
      dispatch(slice.actions.hasError(error.toString()));
    }
  };
}

export function getCustomerCompanySelectList() {
  return async (dispatch) => {
    try {
      const objData = {
        path: '/customerCompany/selectList'
      };

      const response = await ApiService.get(objData);
      // console.log('response:', response);
      dispatch(getSelectLists(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.toString()));
    }
  };
}

export function getCustomerCompanyInsert(NewLists) {
  return async (dispatch) => {
    try {
      const data = new FormData();
      Object.keys(NewLists).forEach((key) => {
        if (key === 'files' && NewLists[key] && NewLists[key][0]) {
          data.append('file', NewLists[key][0]);
        } else if (NewLists[key] !== null && NewLists[key] !== undefined) {
          data.append(key, NewLists[key]);
        }
      });

      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/customerCompany/customerCompanyUpload`, data, getMultipartConfig());

      if (response.status === 200) {
        dispatch(createCustomerCompany(response.data));
        return { success: true, data: response.data };
      } else {
        return { success: false, message: response.data.message };
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error.toString()));
      return { success: false, error };
    }
  };
}

export function getCustomerCompanyUpdate(NewLists, id, flag) {
  return async (dispatch) => {
    try {
      let response;
      if (flag === 'Y') {
        const data = new FormData();
        Object.keys(NewLists).forEach((key) => {
          if (key === 'files' && NewLists[key][0]) {
            data.append('file', NewLists[key][0]);
          } else {
            data.append(key, NewLists[key]);
          }
        });
        response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/customerCompany/customerCompanyUpdate`, data, getMultipartConfig());
      } else {
        const objData = {
          path: '/customerCompany/update',
          data: NewLists
        };
        response = await ApiService.post(objData);
      }

      if (response.status === 200) {
        dispatch(updateCustomerCompany(response.data));
        return { success: true, data: response.data };
      } else {
        return { success: false, message: response.data.message };
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error.toString()));
      return { success: false, error };
    }
  };
}

export function getCustomerCompanyDelete(companyId) {
  return async (dispatch) => {
    try {
      const objData = {
        path: '/customerCompany/delete',
        data: { id: companyId }
      };

      const response = await ApiService.post(objData);
      if (response.status === 200) {
        dispatch(deleteCustomerCompany(companyId));
        return { success: true, data: response.data };
      } else {
        throw new Error(response.data.message);
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error.toString()));
      throw error;
    }
  };
}
